import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import LinkElement from './link-element'

import styles from './navigation-wrapper.module.css'

const propTypes = {
    className: PropTypes.string,
    containerId: PropTypes.string.isRequired
}

/**
 * Generation of the main navigation structure.
 *
 * @param {ReactElement[]} props.children - Children with properties for link generation
 * @param {string} props.containerId - The container id which the link element belongs to
 * @returns {ReactElement}
 */
const NavigationWrapper = props => {
    const linkElements = React.Children.map(props.children, child => {
        return <LinkElement containerId={props.containerId} child={child} />
    })

    return (
        <nav className={cx(styles['navbar'], props.className)}>
            <ul className={styles['nav']}>{linkElements}</ul>
        </nav>
    )
}

NavigationWrapper.propTypes = propTypes

export default NavigationWrapper
